
import { useCallback, useEffect, useState } from "react"
import * as service from "../service/StpTimeSheetApi"
import { useDispatch, useSelector } from "react-redux"
import { message } from "antd"
import { setIsLoading, setRolePaginationList } from "../slices/TimeSheetMasterDataSlice";
import { useNavigate } from "react-router-dom";
import useStpTimeSheetCreateRole from "./useStpTimeSheetCreateRole";
import { useTranslation } from "react-i18next";

function useTimeSheetMasterData() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { onSubmit, onEdit } = useStpTimeSheetCreateRole()
    const [paginationRole, setPaginationRole] = useState({ page: 0, size: 10 })
    const { currentCompany, currentEmployee } = useSelector((state) => state.company)
    const { isLoading, rolePaginationList } = useSelector((state) => state.timeSheetMasterData)

    const toParams = useCallback((params) => {
        const { pagination = {}, sortBy = [] } = params;
        const modifiedParams = {
            ...params,
            page: pagination.page || 0,
            size: pagination.pageSize || 10,
            sortBy: sortBy
                .filter((s) => s.order !== undefined)
                .map((s) => ({
                    direction: s.order === "descend" ? "desc" : "asc",
                    property: s.field,
                })),
        };
        return modifiedParams;

    }, [])

    const getStpTimeSheetRoleList = useCallback(async (params) => {
        try {
            dispatch(setIsLoading(true))
            const response = await service.getStpTimeSheetRoleList({
                ...params,
                companyId: currentCompany,
                employeeId: currentEmployee
            })
            dispatch(setRolePaginationList(response?.data?.page?.content || []))
            setPaginationRole({
                ...params?.pagination,
                current: response?.data?.page?.number + 1,
                pageNo: response?.data?.page?.number + 1,
                page: response?.data?.page?.number + 1,
                total: response.data?.page?.totalElements,
                size: response?.data?.page?.size
            });
            dispatch(setIsLoading(false))
        } catch (error) {
            console.log("error ", error);
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee])

    const onRoleStatusChange = useCallback(async (status, record) => {
        try {
            dispatch(setIsLoading(true))
            const response = await service.updateStpTimeSheetRoleStatusFlag({
                companyId: currentCompany,
                employeeId: currentEmployee,
                statusFlag: status ? "ACTIVE" : "INACTIVE",
                stpTimeSheetRoleId: record?.stpTimeSheetRoleId
            })
            getStpTimeSheetRoleList({ page: 0, size: 10 });
            message.success(t("common.success"))
            dispatch(setIsLoading(false))
        } catch (error) {
            message.error(t("common.error"))
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee, getStpTimeSheetRoleList])

    const onPageChange = useCallback(
        (tablePagination, tableFilters, tableSorter, tableExtra) => {

            const modifiedSorter = Array.isArray(tableSorter)
                ? [...tableSorter]
                : [tableSorter];

            const modifiedParams = toParams({
                pagination: {
                    page: tablePagination?.current - 1,
                    size: tablePagination?.pageSize,
                    pageSize: tablePagination?.pageSize,
                    current: tablePagination.current - 1,
                },
                sortBy: modifiedSorter,
            });
            getStpTimeSheetRoleList(modifiedParams);
        },
        [getStpTimeSheetRoleList]
    );

    useEffect(() => {
        if (currentCompany) {
            getStpTimeSheetRoleList({ page: 0, size: 10 })
        }
    }, [currentCompany])

    return {
        isLoading,
        rolePaginationList,
        getStpTimeSheetRoleList,
        onRoleStatusChange,
        onPageChange,
        paginationRole: paginationRole,
        onEdit,
        onSubmit
    }

}
export default useTimeSheetMasterData;